// extracted by mini-css-extract-plugin
export default {"editContainer":"photoEditor__editContainer__hFMPg","loaderWrapper":"photoEditor__loaderWrapper__bwIXa","loader":"photoEditor__loader__CDI2x","spin":"photoEditor__spin__WZG8w"};